import { Button, Typography } from "@material-ui/core";
import OpenInNewIcon from "@material-ui/icons/OpenInNew";
import Moment from "moment-timezone";
import React, { useEffect, useReducer, useState } from "react";
import translate from "../../../i18n/translate";
import { IFeedbackData, ISessionRating } from "../../../interfaces";
import ErrorPage from "../../shared/ErrorPage/ErrorPage";
import Loader from "../../shared/Loader/Loader";
import SessionRatingComponent from "../../shared/SessionRatingPopup/SessionRatingComponent";
import Toaster from "../../shared/Toaster/Toaster";
import "./SessionReport.scss";
import { useSelector, useDispatch } from "react-redux";
import allActions from "../../../redux/actions";
import { useLocation } from "react-router-dom";
import { getCookieValue } from "../../../cookieHelper";

const SessionReport = (Props: any) => {
  const [, setComment] = useState("");
  const allInfo = useSelector((state: any) => state);
  const dispatch = useDispatch();
  const location: any = useLocation();  
  const [isReadOnly, setReadOnly] = useState(true);
  const [loaderFlag, setLoaderFlag] = useState(true);
  const [issessiondisabled, setsessiondisabled] = useState(true);
  const [teacherCommentVisible, setTeacherCommentVisible] = useState(false);
  const [, setRatingPopup] = useState(false);
  const [sessionRatingProps, setSessionRating] = useState({} as ISessionRating);
  const SessionDetails: ISessionRating = {} as ISessionRating;
  const [isclassroomLink, setclassroomLink] = useState("");
  let [status, setstatus] = useState(0);
  const [assignmentsArray, setAssignmentsArray] = useState<any[]>([]);
  const [isFeedbackHit, setFeedbackHit]= useState(false);

  let session_GetstartDate: any;
  let session_starttimeUTC: any;
  let startTime: any;
  let durationMins: any;
  let response: any;
  let learnerresponse: any;
  let classroomLink: any;
  let teacherComment: any;
  let SessionID: any;
  let Status: any;
  let Coach_name: any;
  let LicenceDetails_One: any;
  let roomWindow: any;
  let feedback_details = {} as IFeedbackData[];

  const [GetstartDate, setGetstartDate] = useState("");
  const [isdurationMins, setdurationMins] = useState("");
  const [starttimeUTC, setstarttimeUTC] = useState("");
  const [isteacherComment, setteacherComment] = useState("");
  const [isstatus, setStatus] = useState("");
  const [isCoach_name, setCoach_name] = useState("");
  const [teacherName, setTeacherName] = useState(false);
  const [teacherNameLang, setTeacherNameLang] = useState(true);

  const [toastOptions, settoastOptions] = useReducer((state: any, newState: any) => ({ ...state, ...newState }), {
    toastOpen: false,
    toastSeverity: "error",
    toastMessageKey: "",
  });

  const handleToastOptionsDirect = (name: string, val: any) => {
    settoastOptions({ [name]: val });
  };

  const toasterHandle = (open: boolean, severity: string, messageKey: string) => {
    handleToastOptionsDirect("toastSeverity", severity);
    handleToastOptionsDirect("toastMessageKey", messageKey);
    handleToastOptionsDirect("toastOpen", !!open);
  };

  const GetFeedback = () => {
    if (
      !!!allInfo.getLearnerFeedback.isLoading &&
      !!!allInfo.getLearnerFeedback.isFailed &&
      !!allInfo.getLearnerFeedback.data
    ) {
      response = allInfo.getLearnerFeedback;
      feedback_details = JSON.parse(response.data.getLearnerFeedback);
      SessionDetails.Content = false;
      SessionDetails.Technology = false;
      SessionDetails.Teacher = false;
      feedback_details.length && feedback_details.forEach((value) => {
        if (parseInt(value.session_id) === parseInt(window.location.href.split("/")[4])) {
          if (value.meta[0].Reasons != null) {
            SessionDetails.Content = value.meta[0].Reasons.indexOf("content") !== -1;
            SessionDetails.Technology = value.meta[0].Reasons.indexOf("technology") !== -1;
            SessionDetails.Teacher = value.meta[0].Reasons.indexOf("teacher") !== -1;
          }
          if (value.meta[0].reasons != null) {
            SessionDetails.Content = value.meta[0].reasons.indexOf("content") !== -1;
            SessionDetails.Technology = value.meta[0].reasons.indexOf("technology") !== -1;
            SessionDetails.Teacher = value.meta[0].reasons.indexOf("teacher") !== -1;
          }
          setReadOnly(true);
          SessionDetails.IsReadOnly = true;
          SessionDetails.Comment = value.comment;
          SessionDetails.Rating = Number(value.rating);
        }
      });
      SessionDetails.SessionID = parseInt(window.location.href.split("/")[4]);
      setSessionRating(SessionDetails);
    }
    if (
      !!allInfo.getLearnerFeedback.isLoading &&
      !!allInfo.getLearnerFeedback.isFailed &&
      !!!allInfo.getLearnerFeedback.data
    ) {
      setstatus(sessionStorage.getItem("isScheduleRequired") !== "true" ? 401 : 1);
    }
  };

  const getLearnerInfo = (resp: any) => {
    if (sessionStorage.getItem("isScheduleRequired") === "true") {
      LicenceDetails_One = resp.data.getpeopleInformation.license[0].licenseId;
    }
  };

  const JWTokenLearner = (resp: any) => {
    if (!!!allInfo.learnerJWToken.isLoading && !!!allInfo.learnerJWToken.isFailed && !!allInfo.learnerJWToken.data) {
      sessionStorage.setItem("JwToken", resp.data.getLearnerJwtoken);
    }
    if (!!allInfo.learnerJWToken.isLoading && !!allInfo.learnerJWToken.isFailed && !!!allInfo.learnerJWToken.data) {
      setstatus(sessionStorage.getItem("isScheduleRequired") !== "true" ? 401 : 1);
    }
  };

  const JWLearnerToken = async (edgeUid: string, username: string) => {
    const geId = allInfo.common.lgId;
    const uuId = allInfo.common.luuId;
    const iss = "ge_coach";

    if (!!!allInfo.learnerJWToken.data) {
      await dispatch(allActions.learnerJWTokenAction.getLearnerJWToken(geId, edgeUid, username, uuId, iss));
    }
    JWTokenLearner(allInfo.learnerJWToken);
  };

  const openRoomWindow = (isclassroomLink: any) => {
    let w = 7680;
    let h = 4320; // default sizes
    if (window.screen) {
      w = window.screen.availWidth - 10;
      h = window.screen.availHeight - 70;
    }
    roomWindow = window.open(
      isclassroomLink,
      "Classroom Window",
      "height=" +
        h +
        ",width=" +
        w +
        ",dependent=yes,location=no,menubar=no," +
        "resizable=yes,scrollbars=yes,status=no,toolbar=no"
    );
    roomWindow.focus();
  };

  const download_assignment_url = (option: any) => {
    if(!sessionStorage.getItem("isDemoUser")) {
      roomWindow = window.open(option);
      roomWindow.focus();
    } else {
      let domain = JSON.parse(process.env.REACT_APP_COOKIE_DOMAINS || "[]") || [];
      window.open(`https://halo${domain[0]}/Handouts/Handout.pdf`, "_blank");
    }
  };

  const GetTMSLearnersessions = () => {
    if (!!!allInfo.tmsLearnerSessions.isLoading && !!allInfo.tmsLearnerSessions.data) {
      response = allInfo.tmsLearnerSessions;
      learnerresponse = response.data.getTMSLearnerSessions;
      for (let i = 0; i < learnerresponse.length; i++) {
        for (let j = 0; j < learnerresponse[i].students.length; j++) {
          SessionID = learnerresponse[i].id;
          if (parseInt(SessionID) === parseInt(window.location.href.split("/")[4])) {
            session_starttimeUTC = Moment.unix(parseInt(learnerresponse[i].startTime)).format("hh:mm A");
            session_GetstartDate = Moment.unix(parseInt(learnerresponse[i].startTime)).format("DD MMMM YYYY");
            durationMins =
              (parseInt(learnerresponse[i].endTime) - parseInt(learnerresponse[i].startTime)) / 60 + " " + "mins";
            teacherComment = learnerresponse[i].teacherComment;
            classroomLink = learnerresponse[i].students[j].classroomLink;
            Status = learnerresponse[i].status;
            Coach_name = learnerresponse[i].teacher.name.replace(/,/g, "");

            startTime =
              session_starttimeUTC +
              " " +
              Moment(Moment.unix(parseInt(learnerresponse[i].startTime)))
                .tz(Moment.tz.guess())
                .format("z");
          }
        }
      }
      if (Status != "finished" && Status != "lost") {
        setsessiondisabled(false);
      }

      if (!!teacherComment) {
        setTeacherCommentVisible(true);
      }

      SessionDetails.SessionDate = session_GetstartDate;
      SessionDetails.SessionDuration = durationMins;
      SessionDetails.SessionTime = startTime;
      SessionDetails.Status = Status;

      setGetstartDate(session_GetstartDate);
      setdurationMins(durationMins);
      setstarttimeUTC(startTime);
      setteacherComment(teacherComment);
      setStatus(Status);
      setCoach_name(Coach_name);
      setclassroomLink(classroomLink);
    }
  };

  const getTMSAssignmentData = async (sessionId: String, learnerToken: String) => {
    if (!!!allInfo.tmsAssignments.data) {
      await dispatch(allActions.tmsAssignmentsAction.getStoreTMSAssignmentInfo(sessionId, learnerToken));
    }
  };

  const getLearnerFeedback = async (learnerToken: string) => {
    if (!!!allInfo.getLearnerFeedback.data && !!!isFeedbackHit) {
      setFeedbackHit(true);
      dispatch(allActions.getLearnerFeedbackAction.getLearnerFeedback(learnerToken));
    }
    GetFeedback();
  };

  const getTMSLearnerSessionData = async (uuId: String) => {
    if (!!!allInfo.tmsLearnerSessions.data) {
      await dispatch(allActions.tmsLearnerSessionsAction.getStoreTMSLearnerSessionInfo(uuId));
    }
    GetTMSLearnersessions();
  };

  const readFileLang = async () => {
    const userLang: string = getCookieValue("ulang") || "";
    if (userLang.toUpperCase() === "JA-JP") {
      setTeacherName(true);
      setTeacherNameLang(false);
    } else {
      setTeacherName(false);
      setTeacherNameLang(true);
    }
  };

  useEffect(() => {
    if (
      !!!allInfo.peopleInformation.isLoading &&
      !!!allInfo.learnerJWToken.isLoading &&
      !!!allInfo.peopleInformation.isFailed &&
      !!!allInfo.learnerJWToken.isFailed &&
      !!allInfo.peopleInformation.data
    ) {
      getLearnerInfo(allInfo.peopleInformation);
      JWLearnerToken(
        allInfo.peopleInformation.data.getpeopleInformation.edgeUid,
        allInfo.peopleInformation.data.getpeopleInformation.username
      );
    }
  }, [allInfo.peopleInformation, allInfo.learnerJWToken]);

  useEffect(() => {
    const sessionId = window.location.href.split("/")[4];
    if (
      !!!allInfo.learnerJWToken.isLoading &&
      !!!allInfo.tmsAssignments.isLoading &&
      !!!allInfo.learnerJWToken.isFailed &&
      !!!allInfo.tmsAssignments.isFailed &&
      !!allInfo.learnerJWToken.data
    ) {
      getTMSAssignmentData(sessionId, allInfo.learnerJWToken.data.getLearnerJwtoken);
    }
  }, [allInfo.learnerJWToken, allInfo.tmsAssignments]);

  useEffect(() => {
    if (!!allInfo.learnerJWToken.data) {
      getLearnerFeedback(allInfo.learnerJWToken.data.getLearnerJwtoken);
    }
  }, [allInfo.learnerJWToken, allInfo.getLearnerFeedback]);

  useEffect(() => {
    const uuId = allInfo.common.luuId;
    if (!!!allInfo.tmsLearnerSessions.isLoading) {
      if (!!!allInfo.tmsLearnerSessions.isFailed) {
        getTMSLearnerSessionData(uuId);
      }
    }
  }, [allInfo.tmsLearnerSessions]);

  useEffect(() => {
    readFileLang();
  }, [getCookieValue("ulang")]);

  useEffect(() => {
    if (
      !!!allInfo.tmsAssignments.isLoading &&
      !!!allInfo.tmsCourses.isLoading &&
      !!!allInfo.tmsLearnerSessions.isLoading
    )
      setLoaderFlag(false);
    else setLoaderFlag(true);
  }, [allInfo.tmsAssignments, allInfo.tmsCourses, allInfo.tmsLearnerSessions]);

  useEffect(() => {
    if(allInfo.tmsLearnerSessions.data && !allInfo.tmsLearnerSessions.loading) {
      let learnerSessions = allInfo.tmsLearnerSessions.data.getTMSLearnerSessions;
      if (learnerSessions.length > 0) {
        const sortedCopy = learnerSessions.slice().sort((a: any, b: any) => a.endTime - b.endTime);
        const completedSessions = sortedCopy.filter((learnerSession: any) => learnerSession.status === "finished" || learnerSession.status === "lost");
        let lastThreeSessions = [];
        if (completedSessions.length < 4) {
          lastThreeSessions = completedSessions;
        }
        if (completedSessions.length >= 4) {
          lastThreeSessions = completedSessions.splice(lastThreeSessions.length - 3, 3);
        }
        if (lastThreeSessions.length > 0) {
          const completedSessionIds: any = [];
          lastThreeSessions.forEach((completedSession: any) => {
            completedSessionIds.push(completedSession.id);
          });
          if (completedSessionIds.length > 0) {
            dispatch(allActions.handoutDetailsAction.getHandoutDetailsAction(completedSessionIds.join(",")));
            // Unused since the tms assignments api is used for now
            // dispatch(allActions.homeworkDetailsAction.getHomeworkDetailsAction(completedSessionIds.join(",")));
          }
        }
      }
    }
  }, [allInfo.tmsLearnerSessions.data]);

  useEffect(() => {
    if(!!!allInfo.tmsAssignments.isLoading && !!allInfo.tmsAssignments.data) {
      let assignments = allInfo.tmsAssignments.data.getTMSAssignments.assignments;
      if(assignments.length > 0 && !sessionStorage.getItem("isDemoUser")) {
        setAssignmentsArray(assignments);
      }

      if(assignments.length > 0 && sessionStorage.getItem("isDemoUser") && location?.state?.productId !== "18" && location?.state?.productId !== "20") {
        setAssignmentsArray(assignments.filter((assignment: any) => assignment.type === "handout"));
      }
    }
  }, [allInfo.tmsAssignments]);

  useEffect(() => {
    if (!!!allInfo.handoutDetails.isLoading && !!!allInfo.handoutDetails.isFailed && !!!allInfo.handoutDetails.isSuccess && !!allInfo.handoutDetails.data) {
      if (allInfo.handoutDetails.data.length > 0 && !sessionStorage.getItem("isDemoUser")) {
        const sessionId = window.location.href.split("/")[4];
        let handoutSession = allInfo.handoutDetails.data.find((handout: any) => handout.id === Number(sessionId));
        let formattedArray = new Array();
        let tempIndex = 0;
        if(!!handoutSession) {
          assignmentsArray.forEach((handout: any) => { 
            if(handout.type === "handout") {
              formattedArray.push({ ...handout, url : `${process.env.REACT_APP_TMS_URL}/${handoutSession.materialDownloadableLinks[tempIndex]}` });
              tempIndex++;
            } else {
              formattedArray.push(handout);
            }
          });
          setAssignmentsArray(formattedArray);
        }
      }
    }
  }, [allInfo.handoutDetails]);

  const getModalView = (payload: any) => {
    return (
      <div className="Inst_Assign_block">
        {payload.map((option: any, index: number) => {
            return (
              <div className="assignment_block" key={index}>
                <span aria-disabled={false}>{option.name}</span>
                <span className="Inst_type" aria-disabled={false}>{option.type}</span>
                <Button
                  type="button"
                  variant="contained"
                  color="primary"
                  disabled={false}
                  onClick={() => download_assignment_url(option.url)}
                >
                  <OpenInNewIcon />
                  <Typography className="subhead_head_body">{translate("SessionReport_open")}</Typography>
                </Button>
              </div>
            );
          }
        )}
      </div>
    )
  }

  return (
    <React.Fragment>
      {status === 0 ? (
        <div className="SessionReport-Container">
          <Toaster
            open={toastOptions.toastOpen}
            severity={toastOptions.toastSeverity}
            toasterClosed={toasterHandle}
            messageKey={toastOptions.toastMessageKey}
          />
          {issessiondisabled ? (
            <React.Fragment>
              <div className="ratings_info greyer session_report">
                <div>
                  <h2>{translate("SessionReport_sessionReport")}</h2>
                </div>
              </div>

              <div className="session_detail_header">
                <div className="Report_Section_title">
                  <span className="sub-heading">{translate("SessionReport_sessionDetails")}</span>
                </div>
                <div className="ratings_container modalContent ui-dialog-content ui-widget-content Session_Report_Page">
                  <div className="session_details">
                    <div className="details_set">
                      <div className="subhead_head">{translate("SessionReport_teacherName")}</div>
                      <div className="subhead_head_body" aria-disabled={false}>
                        {isCoach_name}
                      </div>
                    </div>
                    <div className="details_set">
                      <div className="subhead_head">{translate("SessionRating_sessionDate")}</div>
                      <div className="subhead_head_body" aria-disabled={false}>
                        {GetstartDate}
                      </div>
                    </div>

                    <div className="details_set">
                      <div className="subhead_head">{translate("SessionRating_sessionTime")}</div>
                      <div className="subhead_head_body" aria-disabled={false}>
                        {starttimeUTC}
                      </div>
                    </div>

                    <div className="details_set">
                      <div className="subhead_head">{translate("SessionRating_sessionDuration")}</div>
                      <div className="subhead_head_body" aria-disabled={false}>
                        {isdurationMins}
                      </div>
                    </div>

                    <div className="details_set">
                      <div className="subhead-head-status">{translate("SessionRating_status")}</div>
                      <div className="subhead-head-body completed">
                        <span>{translate("SessionRating_completed")}</span>
                      </div>
                    </div>
                    {!!!sessionStorage.getItem("isDemoUser") && (
                      <Button
                        type="button"
                        variant="contained"
                        disabled={false}
                        color="primary"
                        onClick={() => openRoomWindow(isclassroomLink)}
                      >
                        <Typography className="subhead_head_body">{translate("SessionReport_sessionReview")}</Typography>
                      </Button>
                    )}
                  </div>
                  <div className="Session_rate">
                    <div className="Report_Section_title">
                      <span className="sub-heading">{translate("SessionReport_rateSession")}</span>
                    </div>
                    <div className="rating_botttom_section">
                      {teacherName && (
                        <div className="ratings_info botttom_part">
                          {isCoach_name} {translate("SessionReport_coachName")}
                        </div>
                      )}
                      {teacherNameLang && (
                        <div className="ratings_info botttom_part">
                          {translate("SessionReport_coachName")} {isCoach_name} ?
                        </div>
                      )}
                      <SessionRatingComponent
                        sessionRating={sessionRatingProps}
                        setRatingPopup={setRatingPopup}
                        StarRating={sessionRatingProps.Rating}
                      ></SessionRatingComponent>
                    </div>
                  </div>
                  {teacherCommentVisible && (
                    <div className="session_feedback_block">
                      <div className="Report_Section_title">
                        <h5>{translate("SessionReport_sessionFeedback")}</h5>
                      </div>
                      <div>
                        <textarea
                          onChange={(event) => setComment(event.target.value)}
                          id="ratings_comment"
                          value={isteacherComment}
                          readOnly={isReadOnly}
                        ></textarea>
                      </div>
                    </div>
                  )}
                  {!!!allInfo.tmsAssignments.isLoading && !!allInfo.tmsAssignments.data && assignmentsArray.length > 0 && (
                    <div className="session_assignment_block">
                      {(allInfo.tmsAssignments.data.getTMSAssignments.instructions !== "" ||
                        assignmentsArray.length > 0) && (
                        <div className="Report_Section_title">
                          <h5>{translate("SessionReport_sessionMaterials_Assignments")}</h5>
                        </div>
                      )}
                      {(allInfo.tmsAssignments.data.getTMSAssignments.instructions !== "") && (
                        <div>
                          <span className="lbl_instruction">{translate("SessionReport_instructions")}:</span>
                          <textarea
                            onChange={(event) => setComment(event.target.value)}
                            placeholder=""
                            id="ratings_comment"
                            value={allInfo.tmsAssignments.data.getTMSAssignments.instructions}
                            disabled={false}
                          ></textarea>
                        </div>
                      )}
                      {assignmentsArray.length > 0 && getModalView(assignmentsArray)}
                    </div>
                  )}
                </div>
              </div>
              <Loader showLoader={loaderFlag} />
            </React.Fragment>
          ) : (
            <div className="Passed_Session">
              <h5>
                <span>{translate("SessionReport_invalidSession_Message")}</span>
              </h5>
            </div>
          )}
        </div>
      ) : (
        <div className="SessionReport-Container">
          <ErrorPage status={status} />
        </div>
      )}
    </React.Fragment>
  );
};

export default SessionReport;